import { render, staticRenderFns } from "./MenuResultsHeader.vue?vue&type=template&id=0ab969bc"
import script from "./MenuResultsHeader.vue?vue&type=script&lang=ts"
export * from "./MenuResultsHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports